import { useTranslation } from 'react-i18next';
import DetailsWrapper from '../../../components/Details/DetailsWrapper';
import HorizontalWrapper from '../../../components/Details/HorizonticalWrapper';
import DetailsLinkedIcon from '../../../components/Details/DetailsLinkedIcon';

interface IDetailsForeas{
  basic_info: any[];
  contact_info: any[];
  comments?: any[];
  collections?: any[];
  documents?: any[];
}

function DetailsForeas(props: IDetailsForeas) {
  const { t } = useTranslation();
  const {basic_info, contact_info, comments, collections, documents } = props;

  return (
    <>
      <HorizontalWrapper title={t('Βασικές Πληροφορίες Φορέα')}
        details={basic_info} />
      <HorizontalWrapper title={t('Στοιχεία Επικοινωνίας και Διεύθυνσης')}
        details={contact_info} />
      {comments && comments?.length > 0 && (
        <DetailsWrapper title={t('Παρατηρήσεις - Σχόλια')}
          detailsProps={{
            rows: comments,
            removeLines: true,
          }}/>
      )}
      {collections && collections?.length > 0 && <DetailsLinkedIcon title={t('Συλλογές Φορέα')} detailsList={collections} />}
      {documents && documents?.length > 0 && <DetailsLinkedIcon title={t('Τεκμήρια Φορέα')} detailsList={documents} />}
    </>
  );
}

export default DetailsForeas;